import { TimelyComparisonSeriesApiItem } from "../services/salesTimelyComparisonDashboardApi";
import { SalesComparisonSeries } from "../components/TimelyComparisonCharts/types";

export const SALES_TIMELY_CHART_DEFINITIONS: Omit<
  SalesComparisonSeries,
  "buckets"
>[] = [
  {
    id: "enquiry",
    name: "Enquiry Chart",
    title: "Enquiry",
    subtitle: "Enquiry volume across historical buckets",
    color: "#2563eb",
    accentBg: "#eff6ff",
  },
  {
    id: "quotation",
    name: "Quotation Chart",
    title: "Quotation",
    subtitle: "Quotation volume across historical buckets",
    color: "#0e7490",
    accentBg: "#ecfeff",
  },
  {
    id: "order",
    name: "Order Chart",
    title: "Order",
    subtitle: "Order volume across historical buckets",
    color: "#0f9f6e",
    accentBg: "#ecfdf5",
  },
  {
    id: "dispatch",
    name: "Dispatch Chart",
    title: "Dispatch",
    subtitle: "Dispatch volume across historical buckets",
    color: "#d2363a",
    accentBg: "#fff1f1",
  },
];

const MONTH_LABELS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const formatApiDate = (isoDate: string): string => {
  const [year, month, day] = isoDate.split("-").map(Number);
  if (!year || !month || !day) return isoDate;
  return `${String(day).padStart(2, "0")} ${MONTH_LABELS[month - 1]} ${year}`;
};

const normalizeBucketLabel = (label: string): string =>
  label
    .replace(/\uFFFD/g, "-")
    .replace(/[\u2013\u2014]/g, "-")
    .replace(/\s*-\s*/g, "-");

export const mergeSalesTimelyComparisonCharts = (
  apiSeries: TimelyComparisonSeriesApiItem[] | undefined,
): SalesComparisonSeries[] => {
  if (!apiSeries?.length) return [];

  const apiById = Object.fromEntries(apiSeries.map((series) => [series.id, series]));

  return SALES_TIMELY_CHART_DEFINITIONS.map((definition) => {
    const apiItem = apiById[definition.id];

    return {
      ...definition,
      name: apiItem?.name ?? definition.name,
      title: apiItem?.title ?? definition.title,
      buckets: (apiItem?.buckets ?? []).map((bucket) => ({
        key: bucket.key,
        label: normalizeBucketLabel(bucket.label),
        startDate: formatApiDate(bucket.start_date),
        endDate: formatApiDate(bucket.end_date),
        value: bucket.value,
      })),
      comparison: apiItem?.comparison,
    };
  });
};
